import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "60",
  height: "60",
  style: {"padding":"5px","box-sizing":"border-box"},
  viewBox: "0 0 131 131"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "131",
  height: "131",
  rx: "20",
  ry: "20",
  style: {"fill":"currentColor"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M91.12 39.43c-.84 8.98-2.27 24.27-3.35 35.75a6.006 6.006 0 0 1-6.55 5.42c-9.68-.93-21.07-1.99-32.2-3.04-2.13 2.14-5.74 5.79-9.02 9.06-.95.95-2.59.41-2.77-.93-.35-2.52-.82-6.11-1.15-9.35-2.34-.22-4.64-.44-6.86-.65a6 6 0 0 1-5.42-6.35c.49-7.77 1.18-16.68 1.57-23.89a6.01 6.01 0 0 1 5.23-5.63l53.77-6.91c3.82-.49 7.1 2.68 6.74 6.51Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M102.81 88.89c-1.8.17-3.66.35-5.55.53-.27 2.62-.65 5.53-.93 7.57-.15 1.08-1.47 1.53-2.25.75-2.65-2.65-5.58-5.6-7.3-7.34-9.01.85-18.24 1.71-26.07 2.46a4.863 4.863 0 0 1-5.31-4.39c-.23-2.42-.47-5.05-.73-7.74 9.05.85 18.33 1.72 26.3 2.48a8.575 8.575 0 0 0 6.62-2.2c1.6-1.45 2.6-3.44 2.8-5.59l.38-4.03c.38-4.1.8-8.49 1.2-12.81l9.73 1.25c2.33.3 4.11 2.21 4.24 4.56.32 5.84.88 13.06 1.27 19.35a4.877 4.877 0 0 1-4.39 5.15Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }